import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { addProp, applyIfExist } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query CoreMembersListPage_Main {
    coreMembers {
      id
      email
      loggedInAt
    }
  }
`)
export const useMainQuery = () => {
  const queryKey = useMainQueryKey()
  const graphQLRequest = useGraphQLRequest()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return R.pipe(
        result.coreMembers ?? [],
        R.map(
          R.piped(
            R.evolve({
              loggedInAt: applyIfExist((raw: string) => new Date(raw)),
            }),
            addProp('fullName', ({ email }) => email), // Using email as display name since firstName/lastName don't exist
          ),
        ),
      )
    },
    queryKey,
  })
}

export type CoreMember = NonNullable<QueryResultOf<typeof useMainQuery>>[number]
